<div class="collaboration-details">
  <h3 nz-typography class="nfl-form-label">Review and Accept</h3>
  <nz-spin nzTip="Loading details..." [nzSpinning]="isLoading">
    <div nz-row class="name-desc-wrapper">
      <div nz-col [nzSpan]="12">
        <div class="nfl-form-label">Name</div>
        <p nz-typography>{{ collaborationDetails?.name }}</p>
      </div>
      <div nz-col [nzSpan]="12">
        <div class="nfl-form-label">Description</div>
        <p nz-typography>{{ collaborationDetails?.description }}</p>
      </div>
    </div>
    <div class="objective-wrapper">
      <div class="nfl-form-label">Objective</div>
      <p nz-typography>{{ collaborationDetails?.objective }}</p>
    </div>
    <div class="agreement-wrapper">
      <form nz-form nzLayout="vertical">
        <nz-form-item>
          <nz-form-control nzErrorTip="Please agree to terms before continue">
            <label nz-checkbox [formControl]="agreeFormControl"
              >I confirm that I am authorized to participate on behalf of my organization</label
            >
          </nz-form-control>
        </nz-form-item>
      </form>
    </div>
  </nz-spin>
</div>
